import { ChangeEventHandler, MouseEventHandler, useState } from "react";

import { RequestCreateServiceReport } from "@models/data-contracts";
import useModalState from "@logics/hooks/useModalState";
import { Divider } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

import * as S from "./ReportForm.style";

interface ReportFormProps extends Pick<RequestCreateServiceReport, "type"> {
  onSubmitReport: (content: string) => void;
}

const ReportForm = ({ type, onSubmitReport }: ReportFormProps) => {
  const [reasonContent, setReasonContent] = useState("");

  const { closeModal } = useModalState();

  const handleChangeTextArea: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setReasonContent(e.target.value);
  };

  const handleSubmitReport: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();

    if (!reasonContent) return;

    onSubmitReport(reasonContent);
  };

  return (
    <S.BottomSheetContainer>
      <S.HeaderWrapper>
        <S.Title name="m">Report {type.toLowerCase()}</S.Title>
        <S.CancelButton type="button" onClick={closeModal}>
          Cancel
        </S.CancelButton>
      </S.HeaderWrapper>
      <Divider size="medium" spacing="none" bgColor={grayScale.main} />
      <S.TextareaWrapper>
        <S.ReportPhrase name="strongS">
          {`Please explain why you are reporting this ${type.toLowerCase()}\nReview of the report may take up to 24 hours.`}
        </S.ReportPhrase>
        <S.ReasonTextarea
          value={reasonContent}
          placeholder="What would you like to report?"
          onChange={handleChangeTextArea}
        />
      </S.TextareaWrapper>
      <S.SubmitButton
        type="button"
        disabled={!reasonContent.trim()}
        onClick={handleSubmitReport}
      >
        Submit Report
      </S.SubmitButton>
    </S.BottomSheetContainer>
  );
};

export default ReportForm;
